<template>
  <svg width="52" height="52" viewBox="0 0 53 52" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.7 18.2a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2zm15.6 10.4a13 13 0 0 0-11.362 6.682 2.6 2.6 0 0 0 .962 3.536 2.6 2.6 0 0 0 1.274.338 2.6 2.6 0 0 0 2.262-1.326A7.8 7.8 0 0 1 34.3 33.8a2.6 2.6 0 0 0 0-5.2zm0-10.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2zM26.5 0C12.14 0 .5 11.64.5 26s11.64 26 26 26 26-11.64 26-26a26 26 0 0 0-26-26zm0 46.8C15.012 46.8 5.7 37.488 5.7 26c0-11.488 9.312-20.8 20.8-20.8 11.488 0 20.8 9.312 20.8 20.8a20.8 20.8 0 0 1-20.8 20.8z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
